import { defineStyle } from '@chakra-ui/react';

const style = defineStyle({
  root: {
    height: '100vh',
    direction: { base: 'column', md: 'row' },
    gap: { base: 4, md: 24 },
    px: { base: '20px', md: '40px' },
    '.mainArticleSkeleton': {
      width: { base: '100%', md: '75%' },
      height: { base: '25%', md: '100%' },
    },
    '.mainArticleVStack': {
      width: { base: '100%', md: '25%' },
      height: { base: '75%', md: '100%' },
      alignItems: 'start',
      justifyContent: 'space-evenly',
      pt: { base: 4, md: '200px' },
      pb: { base: 4, md: 8 },
    },
    '.mainArticleSkeletonText1': {
      mt: '4',
      noOfLines: 4,
      spacing: '4',
      width: '100%',
    },
    '.mainArticleSkeletonText2': {
      noOfLines: 10,
      spacing: '4',
      width: '100%',
    },
    '.mainArticleSkeletonText3': {
      noOfLines: 1,
      spacing: '4',
      width: '100%',
    },
    '.mainArticleSkeletonCircle': {
      w: '150px',
      h: '50px',
    },
  },
});

export default style;
